module.exports = function(it){
  return typeof it == 'function';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.is-function.js
 ** module id = 14
 ** module chunks = 0
 **/